import { createRouter, createWebHistory } from 'vue-router'
import { routes } from "@/config/router.config.js"
import { tokenStore } from "@/store/modules/tokenUse.js"
import { menuStore } from "@/store/modules/menuUse.js"
import { authLoginStore } from "@/store/modules/autoLogin";
import { userStore } from "@/store/modules/user";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const whiteList = ['/', '/login', '/register', '/404'];

router.beforeEach((to, from) => {
  const { getMenuList } = menuStore();
  const { getToken } = tokenStore();
  const { clearAllAutoLogin } = authLoginStore();
  const { removeUserInfo } = userStore();
  const token = getToken();
  const menuList = getMenuList();

  if (whiteList.includes(to.path)) return true;

  // 进入了没授权的菜单，去404
  let allMenuPath = [];
  menuList.map(item => {
    if (item.children?.length > 0) {
      item.children.map(ev => {
        allMenuPath.push(`/${item.path}/${ev.path}`)
      })
    } else {
      allMenuPath.push(`/${item.path}`)
    }
  })
  if (allMenuPath.findIndex(path => path === to.path) === -1 && to.name !== 'index') {
    return { path: from.fullPath };
  }

  // 没token或者没权限菜单，去登陆
  if (!token || menuList.length === 0) {
    clearAllAutoLogin();
    removeUserInfo();
    return { path: "/login" };
  } else {
    return true;
  }
})

export default router
